


































































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import { UserModule } from '@/store/modules/user.module'
import TextArea from '@/components/inputs/TextArea.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import ScrollView from '@/components/ScrollView.vue'
import Card from '@/components/Card.vue'
import Mentions from '@/components/Mentions.vue'
import {
  IAdminTask,
  IChainComments,
  IChainUserComment,
  IUser
} from '@zunta/configurations'
import { ChainModule } from '@/store/modules/chain.module'
import DropdownNav from '@/components/DropdownNav.vue'
import { ISelectItem } from '@/interfaces'

const sortBy = require('lodash.sortby')

@Component({
  components: {
    ScrollView,
    DropdownNav,
    Mentions,
    Icon,
    DateTimeLabel,
    Card,
    TextArea
  },
  props: {
    chain: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'chain'
    }
  }
})
export default class ChainComments extends Vue {
  textMessage: string = '';
  replyMessage: string = '';
  wantReplyTo: number | null = null;
  wantEditMessage: number | null = null;
  formattedComments: any = [];
  pinnedPopup: boolean = false
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store);
  userModuleInstance: UserModule = getModule(UserModule, this.$store);

  get user () {
    return this.$store.state.user.selectedUser
  }

  get commentList (): (IChainComments | IChainUserComment)[] {
    let comments = []
    if (this.$props.type === 'user') {
      comments = this.$store.state.user.comments
    } else {
      comments = this.$store.state.chain.comments
    }
    return comments
  }

  get pinnedComments () {
    return this.commentList
      .filter(comment => comment.pinned)
      .sort((a, b) => a.updatedAt > b.updatedAt ? -1 : 1)
  }

  currentPinIndex = 0;

  get usersOptions () {
    return this.$store.state.user.users.map((item: IUser) => {
      return {
        label: `${item.firstName ? item.firstName : ''} ${item.lastName ? item.lastName : ''
          }`,
        key: `${item.firstName ? item.firstName : ''} ${item.lastName ? item.lastName : ''
          }`,
        replaceValue: item.id,
        value: `${item.firstName ? item.firstName : ''}${item.lastName ? item.lastName : ''
          }`
          .split(' ')
          .join('')
      }
    })
  }

  changeIndex (action: string) {
    if (action === 'positive') {
      if (this.pinnedComments.length - 1 === this.currentPinIndex) {
        return
      }
      this.currentPinIndex++
    } else {
      if (this.currentPinIndex === 0) return
      this.currentPinIndex--
    }
  }

  scrollDown () {
    const area: any = document.querySelector('.comments-content')
    if (!area) return
    area.scrollTo({
      top: area.scrollHeight
    })
  }

  getDotActions (comment: IChainComments | IChainUserComment): ISelectItem[] {
    return [
      {
        key: 'reply',
        value: 'reply',
        content: 'Reply',
        icon: 'reply'
      },
      {
        icon: 'pin-comment',
        key: 'pin',
        value: 'pin',
        content: comment.pinned ? 'Unpin' : 'Pin'
      },
      {
        icon: 'edit',
        key: 'edit',
        value: 'edit',
        content: 'Edit'
      },
      {
        icon: 'trash',
        key: 'remove',
        value: 'remove',
        content: 'Remove'
      }
    ]
  }

  formatText (text: string) {
    return text.replace(/[\n]/g, '<br/>')
  }

  updateText (value: string) {
    this.textMessage = value
  }

  updateReplyText (value: string) {
    this.replyMessage = value
  }

  replyTo (commentId: number) {
    this.wantReplyTo = commentId
  }

  async fetchComments () {
    if (this.$props.type === 'user') {
      await this.userModuleInstance.fetchChaiUserComments(this.user.id)
    } else {
      await this.chainModuleInstance.fetchChainComments(this.$props.chain.id)
    }
  }

  handleTextMessageChange (event: any, checkInputSymbol?: Function) {
    this.textMessage = event.target.innerHTML
    if (checkInputSymbol) {
      checkInputSymbol(event)
    }
  }

  openTask (task: IAdminTask) {
    this.$router.push({
      path: this.$route.path,
      params: this.$route.params,
      query: { ...this.$route.query, activeTask: task.id.toString() }
    })
  }

  handleReplyMessageChange (event: any, checkInputSymbol?: Function) {
    this.replyMessage = event.target.innerHTML
    if (checkInputSymbol) {
      checkInputSymbol(event)
    }
  }

  setTextMessage () {
    // @ts-ignore
    this.textMessage = this.$refs.textMessageBox.innerHTML
  }

  getCommentUserTooltip (comment: any) {
    return comment.user
      ? `${comment.user.firstName || ''} ${comment.user.lastName || ''}`
      : 'System'
  }

  setReplyMessage () {
    // @ts-ignore
    if (this.$refs.replyMessageBox.length > 0) {
      // @ts-ignore
      this.replyMessage = this.$refs.replyMessageBox[0].innerHTML
    }
  }

  async mounted () {
    await this.fetchComments()
    this.scrollDown()
    this.$watch('commentList', () => {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.scrollDown()
      })
    }, { immediate: true })
  }

  async handleSelectAction (comment: any, item: ISelectItem) {
    console.log('comment', comment, item)
    switch (item.value) {
      case 'reply':
        this.replyTo(comment.id)
        break
      case 'remove':
        this.removeComment(comment.id)
        break
      case 'pin':
        this.pinComment(comment)
        this.currentPinIndex = 0
        break
      case 'edit':
        this.wantEditMessage = comment.id
        this.textMessage = comment.text
        // @ts-ignore
        this.$refs.textMessageBox.innerHTML = comment.text
        // @ts-ignore
        this.$refs.textMessageBox.focus()
        break
    }
  }

  async pinComment (comment: IChainComments | IChainUserComment) {
    if (this.$props.type === 'user') {
      await this.userModuleInstance.changeChainUserCommentPin({
        commentId: comment.id,
        pin: !comment.pinned
      })
    } else {
      await this.chainModuleInstance.changeChainCommentPin({
        commentId: comment.id,
        pin: !comment.pinned
      })
    }
    await this.fetchComments()
  }

  async removeComment (id: number) {
    if (this.$props.type === 'user') {
      await this.userModuleInstance.removeChainUserComment(id)
    } else {
      await this.chainModuleInstance.removeChainComment(id)
    }
  }

  getTaskLabelTooltip (comment: any) {
    return `
      ${this.getTaskLabelWithTakeaway(comment)}
    `
  }

  getTaskLabelWithTakeaway (comment: any) {
    const label = this.getTaskLabel(comment)
    return `${label}${comment.isTakeaway ? '/Takeaway' : ''}`
  }

  getTaskLabel (comment: any) {
    const task = comment.task
    let template

    if (task.category) {
      return task.category
    }
    if (task.trainingMilestone) {
      template = task.trainingMilestone.template
        ? task.trainingMilestone.template
        : null
    }
    if (task.onboardingMilestone) {
      template = task.onboardingMilestone.template
        ? task.onboardingMilestone.template
        : null
    }
    if (!template) {
      return 'No Milestone'
    }
    if (!template.parent) {
      return template.milestone
    }
    return template.parent.milestone
  }

  async submitMessage (message?: string, baseComment?: number) {
    console.log('message', message)
    if (message || this.textMessage) {
      if (this.$props.type === 'user') {
        if (this.wantEditMessage) {
          await this.userModuleInstance.updateChainUserComment({
            id: this.wantEditMessage,
            text: message || this.textMessage
          })
        } else {
          await this.userModuleInstance.addUserComment({
            data: {
              text: message || this.textMessage,
              baseComment: baseComment || null
            },
            userId: this.user.id
          })
        }
      } else {
        if (this.wantEditMessage) {
          await this.chainModuleInstance.updateChainComment({
            id: this.wantEditMessage,
            text: message || this.textMessage
          })
        } else {
          await this.chainModuleInstance.addChainComment({
            data: {
              text: message || this.textMessage,
              baseComment: baseComment || null
            },
            chainId: this.$props.chain.id
          })
        }
      }
      await this.fetchComments()
    }
    this.replyMessage = ''
    this.textMessage = ''
    // @ts-ignore
    this.$refs.textMessageBox.innerHTML = ''
    this.wantReplyTo = null
    this.wantEditMessage = null
  }
}
